export default __webpack_public_path__ + "static/media/instrument-stainless-steel.57aafc7f.jpeg";